import LegalPage from "../components/LegalPage";

// Sourced from mysteryranch.com/privacy-policy. Sections summarized to
// keep the page light; the canonical/legal version of each section
// lives in NetSuite-managed CMS once that's wired up. Authoritative
// copy is the public site.
export default function PrivacyPolicy() {
  return (
    <LegalPage
      eyebrow="Legal"
      title="Privacy Policy"
      updated="2026-01-01"
      summary="How Mystery Ranch collects, uses, shares, and protects personal information across our public and B2B storefronts."
      sections={[
        {
          id: "collection",
          title: "What We Collect and Why",
          body:
            "We gather identity, contact, transaction, device, and behavioral information directly from users and automatically through tracking technologies. We use this data to process orders, improve services, comply with legal obligations, prevent fraud, and personalize marketing.",
        },
        {
          id: "sensitive",
          title: "Sensitive Personal Information",
          body:
            "We do not knowingly collect sensitive data such as social security numbers, racial or ethnic origin, political opinions, or religion. We do not use sensitive information for profiling or share it for incompatible purposes.",
        },
        {
          id: "analytics",
          title: "Analytics and Digital Tools",
          body:
            "We use third-party analytics platforms — including Google Analytics, Google Ads, and Facebook — to track behavior, improve site design, and deliver targeted advertising. You can opt out via Google's privacy controls and other advertising preference centers.",
        },
        {
          id: "disclosures",
          title: "Disclosures",
          body:
            "We may share personal information with affiliates, service providers, marketing partners, and social media platforms. We disclose data when legally required or to protect business interests, and may share information in a merger or acquisition.",
        },
        {
          id: "sales",
          title: "Sales / Shares and Targeted Advertising",
          body:
            "We do not sell personal information for money but do share data with advertising partners for targeted marketing. Opt out via the \"Do Not Sell or Share My Personal Information\" control or by enabling universal opt-out signals like Global Privacy Control.",
        },
        {
          id: "rights",
          title: "Your Rights and Choices",
          body:
            "You can deactivate accounts, unsubscribe from communications, opt out of targeted advertising, access your data, request deletion, or correct inaccurate information. Requests require identity verification.",
        },
        {
          id: "appeals",
          title: "Appeals",
          body:
            "Residents of certain U.S. states may appeal privacy request decisions to our Privacy Team or General Counsel within 45 days.",
        },
        {
          id: "automated",
          title: "Profiling and Automated Decision-Making",
          body:
            "We do not profile or use any form of automated processing on your personal information that produces significant legal effects under applicable privacy laws.",
        },
        {
          id: "california",
          title: "California \"Shine the Light\"",
          body:
            "California residents may request annual disclosure of third parties with whom we shared personal information for direct marketing purposes by emailing privacy@mysteryranch.com.",
        },
        {
          id: "cookies",
          title: "Cookies",
          body:
            "We and our service providers use cookies and web beacons to enhance experience, track marketing effectiveness, and enable cart functionality. Manage cookies via your browser or our cookie preference tool.",
        },
        {
          id: "mobile",
          title: "Mobile Access and Location-Based Services",
          body:
            "Our services are accessible on mobile devices and may use location data to personalize content. Disable location services in your device settings to opt out.",
        },
        {
          id: "minors",
          title: "Minors",
          body:
            "Services are not directed at minors. We do not knowingly collect data from children without valid parental consent and do not sell or share information from users under 18.",
        },
        {
          id: "third-party",
          title: "Links to Third Parties and Social Media",
          body:
            "Links to external sites carry their own privacy policies. Review them before sharing personal information on third-party platforms.",
        },
        {
          id: "security",
          title: "Keeping Your Information Safe",
          body:
            "We implement reasonable physical, electronic, and administrative measures to protect personal data. Email and social media communications may not be encrypted.",
        },
        {
          id: "retention",
          title: "Retention",
          body:
            "We retain personal information only as long as necessary for the stated purposes or as required by law. Periods depend on relationship duration, legal obligations, and litigation considerations.",
        },
        {
          id: "updates",
          title: "Updates to This Policy",
          body:
            "We may modify this policy with changes posted to the website. Material changes typically apply only to information collected after the new policy takes effect.",
        },
        {
          id: "accessibility",
          title: "Accessibility",
          body:
            "We commit to WCAG 2.1 Level AA conformance and use accessibility tooling to support users with disabilities. We welcome feedback on accessibility barriers.",
        },
        {
          id: "sms",
          title: "Text Messaging Terms",
          body:
            "By opting in you consent to receive recurring promotional and marketing SMS. Reply STOP to unsubscribe. Standard carrier rates apply.",
        },
        {
          id: "contact",
          title: "Contact Us",
          dl: [
            { label: "Phone", value: "1-833-548-1999" },
            { label: "Email", value: "privacy@mysteryranch.com" },
            { label: "Response", value: "Within 2 business days" },
          ],
        },
      ]}
    />
  );
}
